module.exports = __webpack_public_path__ + "img/_ABS9695(1).806586e6.jpg";